import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// import useChecklist from '../../hooks/useChecklist'

import Pagination from "../../components/Pagination";
import Screen from "../../components/Screen";
import ChecklistCard from "../../components/ChecklistCard";
// import CategoryFilter from '../category/CategoryFilter'
import EmptyData from "../../components/EmptyData";
import useAuth from "../../hooks/useAuth";
import appContext from "../../app/contextState/context";
import { ChecklistContext } from "../../hooks/checklistContext";
import SubmitButton from "../../components/SubmitButton";
import CompanyModal from "../../components/companyModel";
import { Box } from "@mui/material";
import api from "../../app/api";
import useAlert from "../../hooks/useAlert";
import { updateChecklist } from "./slice";

const Collection = () => {
  const location = useLocation();
  const { collection } = useSelector((state) => state.checklist);
  const {
    selectedChecklists,
    setSelectedChecklists,
    setLoading,
    loading:btnLoading
  } = useContext(appContext);
  const [showCompanyModel, setShowCompanyModel] = useState(false)
  const { user, isAdmin } = useAuth()
  // const state = useContext(appContext);
  // const { loading } = state;
  const { limit, page, fetchChecklists, setPage, setLimit,loading,toggleFavourite } =
    useContext(ChecklistContext);
  const { isCompany, isManager } = useAuth();
  const [filter, setFilter] = useState({
    company: "",
    category: "",
  });
  const {showAlert} = useAlert()
  const onAddCompanyChecklists = async (companyID)=>{
    setLoading(companyID)
    try {
      let ids = selectedChecklists.map(item=>item._id)
      await api.post("/checklist/assignChecklistToCompany", { companyID,checklistIds:ids });
      setSelectedChecklists([])
      showAlert("Checklist(s) assigned successfully.", "success");
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
    }finally{
      setLoading(null)
    }
  }
  const template = location?.search.split("?template=")[1];
  const review = location?.search.split("?review=")[1];
  const isFavourite = location?.search.split("?favourite=")[1];
  const title = template ? "Templates" : review ? "Reviews" : "Checklist";
  const path = template
    ? "/checklists?template=true"
    : review
      ? "/checklists?review=true"
      : "/checklists";

  const params = {
    page,
    limit,
    company: filter.company,
    category: filter.category,
    ...(template ? { template: true } : {}),
    ...((isFavourite ? { isFavourite: true } : {})),
    ...(review ? { status: "pending" } : {}),
    isCompany,
    isManager,
  };

  useEffect(() => {
    // if(isFavourite){
    //   fetchFavouriteChecklists(params);
    // }else{
      
    // }
    fetchChecklists(params);
  }, [filter, page, limit, review, template, isFavourite]);
  useEffect(() => {
    setPage(1);
  }, [template]);

  const data = collection;
  return (
    <Screen
      loading={loading}
      filter={filter}
      setFilter={setFilter}
      faqsId={"checklist"}
      flow={[
        { label: title, to: path },
        { label: "Home", to: "/checklists" },
        { label: title, to: path },
      ]}
      dontShowCompany={template ? true : false}
      allowed={template && (user?.subscriptionID?.allowedCLTemplates != undefined && !user?.subscriptionID?.allowedCLTemplates && !isAdmin)}
    >
      {isAdmin && (
      <Box sx={{display:'flex', justifyContent:'flex-end', mb:'20px'}}>
        <SubmitButton
          title={"Assign"}
          onClick={() => setShowCompanyModel(true)}
          color={"success"}
          loaderColor={"white"}
          disabled={selectedChecklists.length < 1}
          style={{ marginRight: "15px" }}
        />
      </Box>
      )}
      <section className="section" id="checklist">
        <EmptyData data={data} onReload={() => fetchChecklists(params)}>
          <div className="row icon-boxes">
            {data?.map((item, index) => {
              return (
                <ChecklistCard
                  data={item}
                  key={index}
                  type="new"
                  template={template}
                  select={template || isAdmin}
                  toggleFavourite={toggleFavourite}
                />
              );
            })}
          </div>
        </EmptyData>
        <Pagination
          data={collection}
          limit={limit}
          page={page}
          setPage={setPage}
          setLimit={setLimit}
        />
      </section>
      <CompanyModal
        show={showCompanyModel}
        handleClose={setShowCompanyModel}
        onClick={onAddCompanyChecklists}
        btnLoading={btnLoading}
      />
    </Screen>
  );
};

export default Collection;
